import { X, type LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

interface Props {
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: ReactNode;
  maxWidthClassName?: string;
  TitleIcon?: LucideIcon;
}

export default ({ title, subtitle, onClose, children, maxWidthClassName = "max-w-lg", TitleIcon }: Props) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/50 p-4 backdrop-blur-sm">
      <button className="absolute inset-0 cursor-default" aria-label="Close dialog" onClick={onClose} />
      <div className={`relative w-full rounded-2xl border border-slate-200 bg-white shadow-xl ${maxWidthClassName}`}>
        <div className="flex items-start justify-between border-b border-slate-200 px-5 py-4">
          <div>
            <div className="flex items-center gap-2">
              {TitleIcon && <TitleIcon className="h-4 w-4 text-indigo-500" />}
              <h3 className="text-base font-bold text-slate-900">{title}</h3>
            </div>
            {subtitle && <p className="mt-1 text-xs font-medium text-slate-400">{subtitle}</p>}
          </div>
          <button className="rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-slate-50 hover:text-slate-600" onClick={onClose}>
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="max-h-[72vh] overflow-y-auto p-5">{children}</div>
      </div>
    </div>
  );
};
